// extracted by mini-css-extract-plugin
export var btn = "G_mY D_tB D_tg d_bz d_bP d_bD d_dw";
export var full = "G_vz d_w d_H";
export var hoverStyle = "G_m1";
export var zoom = "G_m2";